import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    text: {
        id: "join.modal.qrCode",
    },
});

export default messages;
